import React, { FunctionComponent } from 'react'
import { Row, Col, Alert, Divider } from 'antd'
import { Formik } from 'formik'
import { Form, FormItem, Input, SubmitButton } from 'formik-antd'
import { ChangePasswordRequest } from '../../../services/api/admin'
import { APIError } from '../../../services/api/client/types'

type Props = {
  error: APIError | null
  initialValues: ChangePasswordRequest
  onSubmit: (form: ChangePasswordRequest, ...args: any[]) => void
}

export const View: FunctionComponent<Props> = ({
  error,
  initialValues,
  onSubmit,
}) => {
  return (
    <>
      <Row>
        <Col span={7}>
          <h2>Смена пароля</h2>

          <Divider />

          {error ? (
            <Alert message="Возникла ошибка при смене пароля" type="error" />
          ) : null}

          <Formik<ChangePasswordRequest>
            initialValues={initialValues}
            onSubmit={onSubmit}
          >
            <Form layout="vertical" size="large">
              <FormItem name="oldPassword" label="Старый пароль">
                <Input name="oldPassword" type="password" />
              </FormItem>

              <FormItem name="password" label="Новый пароль">
                <Input name="password" type="password" />
              </FormItem>

              <SubmitButton>Сменить</SubmitButton>
            </Form>
          </Formik>
        </Col>
      </Row>
    </>
  )
}
